export default __webpack_public_path__ + "static/media/robot-blue.5006e28c.svg";